import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.selectKit.options.showFullTitle}}
  <div
    lang={{this.lang}}
    title={{this.title}}
    data-value={{this.value}}
    data-name={{this.name}}
    class="select-kit-selected-name selected-name choice"
  >
    {{#if this.selectKit.options.formName}}
      <input
        type="hidden"
        name={{this.selectKit.options.formName}}
        value={{this.value}}
      />
    {{/if}}

    {{#if this.item.icon}}
      {{d-icon this.item.icon}}
    {{/if}}

    <span class="name">
      {{this.label}}
    </span>

    {{#if this.shouldDisplayClearableButton}}
      <DButton
        @icon="times"
        @action={{fn this.selectKit.deselect this.item}}
        @ariaLabel="clear_input"
        class="btn-clear"
      />
    {{/if}}
  </div>
{{else}}
  {{#if this.item.icon}}
    <div
      lang={{this.lang}}
      class="select-kit-selected-name selected-name choice"
    >
      {{d-icon this.item.icon}}
    </div>
  {{/if}}
{{/if}}
*/
{
  "id": "hvUcAadu",
  "block": "[[[41,[30,0,[\"selectKit\",\"options\",\"showFullTitle\"]],[[[1,\"  \"],[10,0],[15,\"lang\",[30,0,[\"lang\"]]],[15,\"title\",[30,0,[\"title\"]]],[15,\"data-value\",[30,0,[\"value\"]]],[15,\"data-name\",[30,0,[\"name\"]]],[14,0,\"select-kit-selected-name selected-name choice\"],[12],[1,\"\\n\"],[41,[30,0,[\"selectKit\",\"options\",\"formName\"]],[[[1,\"      \"],[10,\"input\"],[15,3,[30,0,[\"selectKit\",\"options\",\"formName\"]]],[15,2,[30,0,[\"value\"]]],[14,4,\"hidden\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"item\",\"icon\"]],[[[1,\"      \"],[1,[28,[35,1],[[30,0,[\"item\",\"icon\"]]],null]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,1],[14,0,\"name\"],[12],[1,\"\\n      \"],[1,[30,0,[\"label\"]]],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"shouldDisplayClearableButton\"]],[[[1,\"      \"],[8,[39,2],[[24,0,\"btn-clear\"]],[[\"@icon\",\"@action\",\"@ariaLabel\"],[\"times\",[28,[37,3],[[30,0,[\"selectKit\",\"deselect\"]],[30,0,[\"item\"]]],null],\"clear_input\"]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"item\",\"icon\"]],[[[1,\"    \"],[10,0],[15,\"lang\",[30,0,[\"lang\"]]],[14,0,\"select-kit-selected-name selected-name choice\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[[30,0,[\"item\",\"icon\"]]],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null]],[]]]],[],false,[\"if\",\"d-icon\",\"d-button\",\"fn\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/selected-name.hbs",
  "isStrictMode": false
});